import React from "react";
import PropTypes from "prop-types";
import { stringReplace } from "utils";
import MatrixResultColumnHeaders from "components/results/MatrixResultColumnHeaders";
import MatrixResultRow from "components/results/MatrixResultRow";

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/results/MatrixResult.scss';

const MatrixResult = ({ result, isActive }) => {
  const { columns, rows, id } = result;

  const matrixId = stringReplace(id, "/", "-");

  return (
    <div className="csw-r-mtrx">
      {columns && <MatrixResultColumnHeaders columns={columns} />}

      <div className="csw-r-mtrx-rows">
        {rows &&
          rows.map((row, index) => {
            return <MatrixResultRow row={row} key={`csw-r-mtrx-row-${matrixId}-${index}`} isActive={isActive} />;
          })}
      </div>
    </div>
  );
};

MatrixResult.propTypes /* remove-proptypes */ = {
  result: PropTypes.object.isRequired,
  isActive: PropTypes.bool,
};

export default MatrixResult;
